export default "__VITE_ASSET__45d107f6__"